@if (esVistaMicroempresario) {
  <microempresario-header></microempresario-header>
} @else {
  <app-header></app-header>
}
<div class="body" [class.detalle-solicitud--v2]="esVistaMicroempresario">
  <div class="container mt-4" [class.detalle-solicitud-v2__panel]="esVistaMicroempresario">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link" [ngClass]="{'active': !historial, '': historial}"
          id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab"
          aria-controls="profile" aria-selected="true">
          Información general del beneficiario
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="home-tab" data-bs-toggle="tab" href="#home" role="tab"
          aria-controls="home" aria-selected="false">
          Información general de la solicitud
        </a>
      </li>
      @if (flujoCaja) {
        <li class="nav-item" role="presentation">
          <a class="nav-link"
            id="caja-tab" data-bs-toggle="tab" href="#caja" role="tab"
            aria-controls="caja" aria-selected="true">
            Información datos flujo de caja
          </a>
        </li>
      }
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="contact-tab" data-bs-toggle="tab" href="#contact" role="tab"
          aria-controls="contact" aria-selected="false">
          Documentos asociados a la solicitud
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" [ngClass]="{'active': historial, '': !historial}"

          id="contact-tab" data-bs-toggle="tab" href="#historial" role="tab"
          aria-controls="contact" aria-selected="false">
          Historial de solicitud
        </a>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade" [ngClass]="{'show active': !historial, '': historial}" id="profile" role="tabpanel"
        aria-labelledby="profile-tab">
        <div class="hr">Información del beneficiario</div>
        <div class="row align-items-center">
          @if (esIntermediario && getSolicitudData("solicitud", "idSolicitudBE") != null) {
            <div class="col-12 col-sm-3 col-md-3 col-lg-3"
              >
              <div class="mb-3 d-flex align-items-center">
                <label class="mb-0 ms-3 me-3 font-weight-bold" for="src">SCR</label>
                <div class="form-control font-weight-bold" style="width: auto;">{{ getSolicitudData("solicitud", "idSolicitudBE") }}</div>
              </div>
            </div>
          }
          <div class="col"></div>
          @if (esIntermediario) {
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
              <div class="d-flex flex-row justify-content-end">
                <div class="mb-3 d-flex align-items-center me-3">
                  <label class="mb-0 ms-3 me-2 font-weight-bold" for="puntajeScoreExperian">Score Experian</label>
                  <div class="form-control font-weight-bold" style="width: auto;">{{ getSolicitudData("InformacionBeneficiario",
                  "puntajeScoreExperian") }}</div>
                </div>
                <div class="mb-3 d-flex align-items-center">
                  <label class="mb-0 ms-3 me-2 font-weight-bold" for="puntajeScoreTransunion">Score Transunion</label>
                  <div class="form-control font-weight-bold" style="width: auto;">{{ getSolicitudData("InformacionBeneficiario",
                  "puntajeScoreTransunion") }}</div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (personaNatural) {
          <div>
            <benecifiario-natural [beneficiario]="solicitud.InformacionBeneficiario"
              [existePropuesta]="solicitud.propuestaSeleccionada.idPropuesta ? true : false"
              [esIntermediario]="esIntermediario"
              [esVistaMicroempresario]="esVistaMicroempresario"></benecifiario-natural>
          </div>
        } @else {
          <beneficiario-juridica [beneficiario]="solicitud.InformacionBeneficiario"
            [existePropuesta]="solicitud.propuestaSeleccionada.idPropuesta ? true : false"
          [esIntermediario]="esIntermediario"></beneficiario-juridica>
        }
        <div class="redes">Redes sociales {{ esVistaMicroempresario ? 'del microempresario' : 'microempresario' }}</div>
        @if (esVistaMicroempresario) {
          <div class="detalle-redes" [class.detalle-redes--empty]="redesVista.length === 0">
            @if (redesVista.length > 0) {
              <ul class="detalle-redes__list">
                @for (red of redesVista; track red.href) {
                  <li class="detalle-redes__item">
                    <span class="detalle-redes__label">{{ red.label }}</span>
                    <a
                      class="detalle-redes__link"
                      [href]="red.href"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ red.url }}
                    </a>
                  </li>
                }
              </ul>
            } @else {
              <p class="detalle-redes__empty-msg">
                El microempresario no registró redes sociales.
              </p>
            }
          </div>
        } @else {
          <div class="card">
            <div class="row" style="padding: 0 1rem">
              @for (red of redesVista; track red.href) {
                <div class="col-12">
                  <a
                    class="text-primary"
                    [href]="red.href"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ red.url }}
                  </a>
                </div>
              }
              @if (redesVista.length === 0) {
                <div class="col-12 m-0 p-0">
                  {{ 'No registro redes sociales el microempresario' | uppercase }}
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="tab-pane fade" id="home" role="tabpanel" aria-labelledby="home-tab">
        <div class="hr">Información general de la solicitud</div>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3">
              <label class="form-label" for="monto">Monto solicitado</label>
              <div class="form-control">
                {{ getSolicitudData('solicitud', 'monto') | pesosCop }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3">
              <label class="form-label" for="plazo">Plazo</label>
              <div class="form-control">
                {{ getSolicitudData('solicitud', 'plazo') }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
            <div class="mb-3">
              <label class="form-label" for="tipoLinea">Tipo de línea</label>
              <div class="form-control">{{ tipoLineaLabel }}</div>
            </div>
          </div>
          @if (esVistaMicroempresario) {
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
              <div class="mb-3">
                <label class="form-label">¿En qué vas a usar el crédito?</label>
                <div
                  class="detalle-destinos"
                  [class.detalle-destinos--empty]="destinosVista.length === 0">
                  @if (destinosVista.length > 0) {
                    <ul class="detalle-destinos__list">
                      @for (dest of destinosVista; track dest.idDestinoCredito) {
                        <li class="detalle-destinos__item">
                          <span class="detalle-destinos__nombre">{{ dest.nombre }}</span>
                          @if (dest.esOtro && textoOtroDestino) {
                            <span class="detalle-destinos__otro">{{ textoOtroDestino }}</span>
                          }
                        </li>
                      }
                    </ul>
                  } @else {
                    <p class="detalle-destinos__empty-msg">
                      No se registraron destinos de crédito en esta solicitud.
                    </p>
                  }
                </div>
              </div>
            </div>
            @if (mostrarDescripcionNecesidadLegacy) {
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                <div class="mb-3">
                  <label class="form-label" for="descripcion">Descripción de la necesidad</label>
                  <textarea
                    id="descripcion"
                    class="form-control"
                    style="height: 100px;"
                    [disabled]="true">{{ textoOtroDestino }}</textarea>
                </div>
              </div>
            }
          }
          @if (esIntermediario) {
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
              <div class="mb-3">
                <label class="form-label">Descripción de la necesidad</label>
                <div
                  class="detalle-destinos"
                  [class.detalle-destinos--empty]="!descripcionNecesidad">
                  @if (destinosVista.length > 0) {
                    <ul class="detalle-destinos__list">
                      @for (dest of destinosVista; track dest.idDestinoCredito) {
                        <li class="detalle-destinos__item">
                          <span class="detalle-destinos__nombre">{{ dest.nombre }}</span>
                          @if (dest.esOtro && textoOtroDestino) {
                            <span class="detalle-destinos__otro">{{ textoOtroDestino }}</span>
                          }
                        </li>
                      }
                    </ul>
                  } @else if (textoOtroDestino) {
                    <p class="detalle-destinos__otro">{{ textoOtroDestino }}</p>
                  } @else {
                    <p class="detalle-destinos__empty-msg">
                      No se registraron destinos de crédito en esta solicitud.
                    </p>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <!-- Se agrega la propuesta del aliado financiero -->
        @if (tipoUsuario == 'intermediario' && datosPropuestaBancoldex == true) {
          <div class="mt-4">
            <div class="hr">PARÁMETROS DE LA OFERTA</div>
            <div class="row">
              <div class="col-12 col-sm-12 text-start">
                <p>Línea de crédito</p>
                <input type="text" name="lineaCreditoBancoldex"
                  [(ngModel)]="detalleSolicitud.propuesta.modalidad" [disabled]="true">
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 text-start">
                  <p>Destino</p>
                  <input type="text" name="destinoBancoldex"
                    [(ngModel)]="detalleSolicitud.propuesta.destino" [disabled]="true">
                  </div>
                </div>
                <div class="row mt-3 text-start justify-content-md-center">
                  <div class="col-12 col-sm-5">
                    <p>Monto</p>
                    <input type="text" name="montoBancoldex"
                      [ngModel]="detalleSolicitud.propuesta.monto | pesosCop"
                      [disabled]="true">
                    </div>
                    <div class="col-12 col-sm-2"></div>
                    <div class="col-12 col-sm-5">
                      <p>Plazo en meses</p>
                      <input type="text" name="plazoBancoldex"
                        [(ngModel)]="detalleSolicitud.propuesta.plazo" [disabled]="true">
                      </div>
                    </div>
                    <div class="row mt-3 text-start justify-content-md-center">
                      <div class="col-12 col-sm-4">
                        <p>Tasa Bancóldex E.A.</p>
                        <input type="text" name="tazaEABancoldex"
                          [(ngModel)]="detalleSolicitud.propuesta.tasaRedescuento" [disabled]="true" />
                        </div>
                        <div class="col-12 col-sm-4">
                          <p>Margen de intermediación E.A.</p>
                          <input type="text" name="margenBancoldex"
                            [(ngModel)]="detalleSolicitud.propuesta.margenIntermediario" [disabled]="true" />
                          </div>
                          <div class="col-12 col-sm-4">
                            <p>Tasa E.A.</p>
                            <input type="text" name="tazaBancoldex" [(ngModel)]="detalleSolicitud.propuesta.tasa"
                              [disabled]="true" />
                            </div>
                          </div>
                          <div class="row mt-3 text-start justify-content-md-center">
                            <div class="col-12 col-sm-5">
                              <p>Periodicidad de pago de capital e intereses</p>
                              <input type="text" name="periodicidadBancoldex"
                                [(ngModel)]="detalleSolicitud.propuesta.nombrePeriodicidad" [disabled]="true" />
                              </div>
                              <div class="col-12 col-sm-2"></div>
                              <div class="col-12 col-sm-5">
                                <p>Período de gracia</p>
                                <input type="text" name="periodoGraciaBancoldex"
                                  [(ngModel)]="detalleSolicitud.propuesta.periodoGracia" [disabled]="true" />
                                </div>
                              </div>
                              <div class="row mt-3 text-center justify-content-md-center">
                                <div class="col-12 col-sm-4 align-self-center">
                                  <div class="col-12 col-sm-12 box">
                                    <span class="number-value">{{
                                      detalleSolicitud.propuesta.desembolsoAproximado
                                      | pesosCop
                                    }}</span>
                                    <p>Valor de oferta</p>
                                  </div>
                                  <div class="col-12 col-sm-12 box">
                                    <span class="number-value">{{
                                      detalleSolicitud.propuesta.cuota
                                      | pesosCop
                                    }}</span>
                                    <p>Valor cuota</p>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-8">
                                  <div class="col-12 col-sm-12 mt-4">
                                    <div class="table-responsive">
                                      <table class="table-bordered tablaCargosGarantias">
                                        <thead>
                                          <tr>
                                            <th scope="col" class="no-styles table-header">
                                              Nombre de cargos y/o garantías
                                            </th>
                                            <th scope="col" class="no-styles table-header">
                                              Valor
                                            </th>
                                            <th scope="col" class="no-styles table-header">
                                              Tipo de cargo y/o garantías
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          @for (
                                            cargoGarantia of detalleSolicitud.propuesta
                                            .neoCargoComisiones; track
                                            cargoGarantia; let i = $index) {
                                            <tr>
                                              <th scope="row">{{ cargoGarantia.descripcion }}</th>
                                              <td>
                                                {{
                                                cargoGarantia.monto
                                                | pesosCop
                                                }}
                                              </td>
                                              <td>{{ cargoGarantia.tipoCargo }}</td>
                                            </tr>
                                          }
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                  <div class="text-start justify-content-start">
                                    <p>Observaciones revisor</p>
                                    <textarea class="form-control" style="height: 100px;"
                                    [disabled]="true">{{detalleSolicitud.propuesta.observaciones}}</textarea>
                                  </div>
                                  <div class="text-start justify-content-start mt-2">
                                    <p>Observaciones aprobador</p>
                                    <textarea class="form-control" style="height: 100px;"
                                    [disabled]="true">{{detalleSolicitud.observacionAprobador.observaciones}}</textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          @if (
                            tipoUsuario == 'intermediario' && datosPropuestaPropios == true
                            ) {
                            <div class="mt-4">
                              <div class="hr">PARÁMETROS DE LA OFERTA</div>
                              <div class="row">
                                <div class="col-12 col-sm-12 text-start">
                                  <p>Línea de crédito</p>
              <input type="text" name="lineaCredito" [(ngModel)]="
                  detalleSolicitud.propuesta.neoParametrizacionLineaDTO.nombre
                " [disabled]="true" />
                                  </div>
                                </div>
                                <div class="row mt-3 text-start justify-content-md-center">
                                  <div class="col-12 col-sm-5">
                                    <p>Monto</p>
              <input type="text" name="monto" [ngModel]="
                  detalleSolicitud.propuesta.monto
                    | pesosCop
                " [disabled]="true" />
                                    </div>
                                    <div class="col-12 col-sm-2"></div>
                                    <div class="col-12 col-sm-5">
                                      <p>Plazo en meses</p>
                                      <input type="text" name="plazo" [(ngModel)]="detalleSolicitud.propuesta.plazo"
                                        [disabled]="true" />
                                      </div>
                                    </div>
                                    <div class="row mt-3 text-start justify-content-md-center">
                                      <div class="col-12 col-sm-12">
                                        <p>Tasa EA*</p>
                                        <input type="text" name="tasa" [(ngModel)]="detalleSolicitud.propuesta.tasa"
                                          [disabled]="true" />
                                        </div>
                                      </div>
                                      <div class="row mt-3 text-start justify-content-md-center">
                                        <div class="col-12 col-sm-5">
                                          <p>Periodicidad de pagos</p>
                                          <input type="text" name="periodicidad"
                                            [(ngModel)]="detalleSolicitud.propuesta.nombrePeriodicidad" [disabled]="true" />
                                          </div>
                                          <div class="col-12 col-sm-2"></div>
                                          <div class="col-12 col-sm-5">
                                            <p>Período de gracia</p>
                                            <input type="text" name="periodoGracia"
                                              [(ngModel)]="detalleSolicitud.propuesta.periodoGracia" [disabled]="true" />
                                            </div>
                                          </div>
                                          <div class="row mt-3 text-center justify-content-md-center">
                                            <div class="col-12 col-sm-4 align-self-center">
                                              <div class="col-12 col-sm-12 box">
                                                <span class="number-value">{{
                                                  detalleSolicitud.propuesta.desembolsoAproximado
                                                  | pesosCop
                                                }}</span>
                                                <p>Valor de oferta</p>
                                              </div>
                                              <div class="col-12 col-sm-12 box">
                                                <span class="number-value">{{
                                                  detalleSolicitud.propuesta.cuota
                                                  | pesosCop
                                                }}</span>
                                                <p>Valor cuota</p>
                                              </div>
                                            </div>
                                            <div class="col-12 col-sm-8">
                                              <div class="col-12 col-sm-12 mt-4">
                                                <div class="table-responsive">
                                                  <table class="table-bordered tablaCargosGarantias">
                                                    <thead>
                                                      <tr>
                                                        <th scope="col" class="no-styles table-header">
                                                          Nombre de cargos y/o garantías
                                                        </th>
                                                        <th scope="col" class="no-styles table-header">
                                                          Valor
                                                        </th>
                                                        <th scope="col" class="no-styles table-header">
                                                          Tipo de cargo y/o garantías
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      @for (
                                                        cargoGarantia of detalleSolicitud.propuesta
                                                        .neoCargoComisiones; track
                                                        cargoGarantia; let i = $index) {
                                                        <tr>
                                                          <th scope="row">{{ cargoGarantia.descripcion }}</th>
                                                          <td>
                                                            {{
                                                            cargoGarantia.monto
                                                            | pesosCop
                                                            }}
                                                          </td>
                                                          <td>{{ cargoGarantia.tipoCargo }}</td>
                                                        </tr>
                                                      }
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                              <div class="text-start justify-content-start">
                                                <p>Observaciones revisor</p>
                                                <textarea class="form-control" style="height: 100px;"
                                                [disabled]="true">{{detalleSolicitud.propuesta.observaciones}}</textarea>
                                              </div>
                                              <div class="text-start justify-content-start mt-2">
                                                <p>Observaciones aprobador</p>
                                                <textarea class="form-control" style="height: 100px;"
                                                [disabled]="true">{{detalleSolicitud.observacionAprobador.observaciones}}</textarea>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      @if (
                                        tipoUsuario !== 'intermediario' && solicitud.solicitud.idEstadoSolicitud_NeoEstadoSolicitud >= 8
                                        ) {
                                        <div>
                                          <div class="hr">Detalle oferta seleccionada</div>
                                          @if (solicitud.propuestaSeleccionada.idPropuesta) {
                                            <div class="row">
                                              <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                                <div class="mb-3">
                                                  <label class="form-label" for="aliado">Aliado</label>
                                                  <div class="form-control">
                                                    {{ solicitud["propuestaSeleccionada"].nombreIntermediario }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                                <div class="mb-3">
                                                  <label class="form-label" for="tasa">Tasa</label>
                                                  <div class="form-control">
                                                    {{ solicitud["propuestaSeleccionada"].tasa }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                                <div class="mb-3">
                                                  <label class="form-label" for="montoAliado">Monto</label>
                                                  <div class="form-control">
                                                    {{
                                                    solicitud["propuestaSeleccionada"].monto | pesosCop
                                                    }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                                                <div class="mb-3">
                                                  <label class="form-label" for="plazoAliado">Plazo</label>
                                                  <div class="form-control">
                                                    {{ solicitud["propuestaSeleccionada"].plazo }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                                                <div class="mb-3">
                                                  <label class="form-label" for="periodo">Período de gracia</label>
                                                  <div class="form-control">
                                                    {{ solicitud["propuestaSeleccionada"].periodoGracia }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="hr col-12">Otros cargos y/o garantias</div>
                                              @if (
                                                solicitud.propuestaSeleccionada.neoCargoComisiones?.length !== 0
                                                ) {
                                                <div class="col-12">
                                                  <div
                                                    class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12 d-flex justify-content-around">
                                                    <div>Cargo y/o garantía</div>
                                                    <div>Valor</div>
                                                    <div>Tipo de cargo y/o garantía</div>
                                                  </div>
                                                  @for (
                                                    cargo of solicitud.propuestaSeleccionada
                                                    .neoCargoComisiones
                                                    ; track
                                                    cargo) {
                                                    <div class="row text-center">
                                                      <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                                        {{ cargo.descripcion }}
                                                      </div>
                                                      <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                                        {{ cargo.monto | pesosCop }}
                                                      </div>
                                                      <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                                        {{ cargo.tipoCargo }}
                                                      </div>
                                                    </div>
                                                  }
                                                </div>
                                              }
                                              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6 mt-4">
                                                <div class="mb-3">
                                                  <label class="form-label" for="cuota">Cuota aproximada a pagar (COP)</label>
                                                  <div class="form-control">
                                                    {{
                                                    solicitud["propuestaSeleccionada"].cuota | pesosCop
                                                    }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6 mt-4">
                                                <div class="mb-3">
                                                  <label class="form-label" for="valor">Valor neto a desembolsar</label>
                                                  <div class="form-control">
                                                    {{
                                                    solicitud["propuestaSeleccionada"].desembolsoAproximado
                                                    | pesosCop
                                                    }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="mb-3">
                                                  <label class="form-label" for="observacion">Observación de la propuesta:</label>
                                                  <textarea class="form-control" style="height: 100px;"
                                                  [disabled]="true">{{ solicitud["propuestaSeleccionada"].observacionesAprobador }}</textarea>
                                                </div>
                                              </div>
                                            </div>
                                          } @else {
                                            <div class="container-fluid text-center mb-5">
                                              No seleccionaste ninguna oferta
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                    @if (flujoCaja) {
                                    <div class="tab-pane fade" id="caja" role="tabpanel" aria-labelledby="caja-tab">
                                      <div class="hr">Información datos flujo de caja</div>
                                      <div class="row">
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="mes">Mes de corte de la información</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'mesCorteInformacion') }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="vendo">Lo que vendo</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'ventas') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="otrosIngesos">Otros ingresos</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'otrosIngresos') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="totalIngresos">Total ingresos</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'totalIngresos') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                          <div class="mb-3">
                                            <label class="form-label" for="ingresosDescripcion">¿A que corresponden los otros ingresos?</label>
                                            <textarea class="form-control" style="height: 100px;"
                                            [disabled]="true">{{ getSolicitudData('FlujoCaja', 'fuenteOtrosIngresos') }}</textarea>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="pagoProveedores">Pago a proveedores</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoProveedores') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="arriendo">Arriendo</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoArriendo') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="administracion">Administración</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoAdministracion') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="serviciosPublicos">Servicios públicos del negocio</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoServiciosPublicos') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="sueldo">Mi sueldo</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoSueldoPropio') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="sueldoAyudantes">Sueldo de mi(s) ayudante(s)</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoSueldoEmpleados') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="celularPlan">Plan de celular del negocio</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoPlanCelular') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="tarjeta">Tarjeta de crédito del negocio</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoTarjetaCredito') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="cuotaCredito">Cuota créditos del negocio</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoCuotaCreditos') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="saldoCredito">¿Cuál es el saldo de los créditos o deudas que tiene el negocio?</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'SaldoDeudas') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="otrosGastos">Otros gastos del negocio</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'pagoOtrosGastos') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="totalGastos">Total gastos</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'totalGastos') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                          <div class="mb-3">
                                            <label class="form-label" for="descripcionGastos">¿A que corresponden los otros gastos?</label>
                                            <textarea class="form-control" style="height: 100px;"
                                            [disabled]="true">{{ getSolicitudData('FlujoCaja', 'fuenteOtrosGastos') }}</textarea>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
                                          <div class="mb-3">
                                            <label class="form-label" for="efectivo">Efectivo disponible</label>
                                            <div class="form-control">
                                              {{ getSolicitudData('FlujoCaja', 'efectivoDisponible') | pesosCop }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    }
                                    <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                      <div class="hr">Documentos</div>
                                      <div class="row">
                                        @if (solicitud?.Documentos?.length === 0) {
                                          <div class="col-12 text-center"
                                            >
                                            No hay archivos cargados
                                          </div>
                                        } @else {
                                          @if (solicitud?.Documentos['fotos']?.length > 0) {
                                            <div class="col-12">
                                              <div class="card d-flex flex-column">
                                                {{ 1 }}. {{ "fotos del establecimiento" | uppercase }}
                                                <div class="row">
                                                  @for (documento of solicitud?.Documentos['fotos']; track documento; let i = $index) {

                                                  @if (documento?.urlArchivo) {
                                                  <div class="col-12 col-lg-3 d-flex flex-column align-items-center">
                                                    <a data-fancybox="gallery" [href]="documento.urlArchivo" class="mx-3">
                                                      <img [src]="documento.urlArchivo" class="rounded imagen" title="Ver foto" />
                                                    </a>

                                                    <button
                                                      type="button"
                                                      [id]="documento.urlArchivo"
                                                      (click)="downloadImages(documento.urlArchivo, documento.nombreDocumento)"
                                                      class="mt-2 fas fa-download text-primary"
                                                      [class.detalle-doc-tip]="esVistaMicroempresario"
                                                      aria-label="Descargar foto"
                                                      [attr.title]="esVistaMicroempresario ? null : 'Descargar foto'">
                                                      @if (esVistaMicroempresario) {
                                                        <span class="detalle-doc-tip__label" role="tooltip">Descargar foto</span>
                                                      }
                                                    </button>
                                                  </div>
                                                  }
                                                  }
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                            @if (solicitud?.Documentos['video']?.length > 0) {
                                              <div class="col-12">
                                                <div class="card d-flex flex-column">
                                                  {{ 2 }}. {{ "Video del establecimiento" | uppercase }}
                                                  <div class="row d-flex justify-content-center">
                                                    @for (
                                                      documento of solicitud.Documentos['video']; track
                                                      documento; let i = $index) {
                                                      @if (documento?.urlArchivo) {
                                                        <div class="col-12 col-xl-5 d-flex flex-column align-items-center">
                                                          <div class="ratio ratio-16x9">
                                                            <video [src]="documento.urlArchivo" class="rounded" controls></video>
                                                          </div>
                                                          <button type="button" [id]="documento.urlArchivo"
                                                            (click)="downloadImages(documento.urlArchivo, documento.nombreDocumento)"
                                                            class="mt-2 fas fa-download text-primary"
                                                            [class.detalle-doc-tip]="esVistaMicroempresario"
                                                            aria-label="Descargar video"
                                                            [attr.title]="esVistaMicroempresario ? null : 'Descargar video'">
                                                            @if (esVistaMicroempresario) {
                                                              <span class="detalle-doc-tip__label" role="tooltip">Descargar video</span>
                                                            }
                                                          </button>
                                                        </div>
                                                      }
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                            @for (
                                              documento of solicitud.Documentos['archivos']; track
                                              documento; let i = $index) {
                                              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                                <div class="card">
                                                  <span>{{ i + (solicitud?.Documentos['video']?.length > 0 ? 3 : 2) }}. {{ documento.tipoDocumento }}</span>
                                                  @if (!documento.multiple) {
                                                    <div class="controls">
                  <button type="button" (click)="
                      downloadFile(
                        documento.idDocumentoSolicitud,
                        documento.nombreDocumento
                      )
                    " class="fas fa-eye text-primary"
                    [class.detalle-doc-tip]="esVistaMicroempresario"
                    aria-label="Ver documento"
                    [attr.title]="esVistaMicroempresario ? null : 'Ver documento'">
                    @if (esVistaMicroempresario) {
                      <span class="detalle-doc-tip__label" role="tooltip">Ver documento</span>
                    }
                  </button>
                                                    </div>
                                                  }
                                                  @if (documento.multiple) {
                                                    <div class="controls">
                                                      @for (subdocumento of documento.documentos; track subdocumento) {
<button type="button" (click)="
                      downloadFile(
                        subdocumento.idDocumentoSolicitud,
                        subdocumento.nombreDocumento
                      )
                    " class="fas fa-eye text-primary"
                      [class.detalle-doc-tip]="esVistaMicroempresario"
                      aria-label="Ver documento"
                      [attr.title]="esVistaMicroempresario ? null : 'Ver documento'">
                      @if (esVistaMicroempresario) {
                        <span class="detalle-doc-tip__label" role="tooltip">Ver documento</span>
                      }
                    </button>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                            }
                                            @if ((solicitud.Documentos['documentosCentralesRiesgo'] && solicitud.Documentos['documentosCentralesRiesgo']?.length > 0) && esIntermediario) {
                                              <div class="w-100">
                                                @for (archivoCentralesRiesgo of solicitud.Documentos['documentosCentralesRiesgo']; track archivoCentralesRiesgo; let i = $index) {
                                                  <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                                    <div class="card">
                                                      {{ i + cantFile + (solicitud?.Documentos['video']?.length > 0 ? 3 : 2) }}. {{
                                                      archivoCentralesRiesgo.tipoDocumento }}
                                                      <div class="controls">
                                                        <button type="button" (click)="downloadFile(archivoCentralesRiesgo.idDocumentoSolicitud,archivoCentralesRiesgo.tipoDocumento)"
                                                          class="fas fa-eye text-primary"
                                                          [class.detalle-doc-tip]="esVistaMicroempresario"
                                                          aria-label="Ver documento"
                                                          [attr.title]="esVistaMicroempresario ? null : 'Ver documento'">
                                                          @if (esVistaMicroempresario) {
                                                            <span class="detalle-doc-tip__label" role="tooltip">Ver documento</span>
                                                          }
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                }
                                              </div>
                                            }
                                            <a id="downloadFile" style="display: none"></a>
                                          }
                                          <div class="col-12 text-end">
                                            <button
                                              type="button"
                                              (click)="downloadAll()"
                                              [class]="esVistaMicroempresario ? 'detalle-solicitud-v2__btn-primary' : 'btn btn-primary hvr-shrink'"
                                            >
                                              Descargar documentos
                                            </button>
                                            <a id="allFile" style="display: none"></a>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="tab-pane fade" [ngClass]="{'show active': historial, '': !historial}"
                                        id="historial" role="tabpanel" aria-labelledby="contact-tab">
                                        <div class="hr">Historial</div>
                                        <div class="row">
                                          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                            <div class="mb-3">
                                              <label class="form-label" for="fechaEnvio">Fecha de envío</label>
                                              <div class="form-control">
                                                {{
                                                getSolicitudData("HistorialSolicitud", "LaSolicitudSeEnvioEl")
                                                ? (getSolicitudData("HistorialSolicitud", "LaSolicitudSeEnvioEl") | date: "dd/MM/yyyy h:mm a" : "en-CA")
                                                : "Por definir"
                                                }}
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                            <div class="mb-3">
                                              <label class="form-label" for="fechaActual">Fecha actual</label>
                                              <div class="form-control">
                                                {{ getSolicitudData("HistorialSolicitud", "fechaActual") | date: "dd/MM/yyyy h:mm a" : "en-CA" }}
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xs-4">
                                            <div class="mb-3">
                                              <label class="form-label" for="fechaPrevista">Fecha prevista</label>
                                              <div class="form-control">
                                                {{
                                                getSolicitudData("HistorialSolicitud", "FechaPrevista")
                                                ? (getSolicitudData("HistorialSolicitud", "FechaPrevista") | date: "dd/MM/yyyy h:mm a" : "en-CA")
                                                : "Por definir"
                                                }}
                                              </div>
                                            </div>
                                          </div>
                                          @if (tipoUsuario == 'microempresario') {
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                              <div class="mb-3">
                                                <label class="form-label" for="estadoActual">Estado actual</label>
                                                <div class="form-control">
                                                  {{ getSolicitudData("HistorialSolicitud", "EstadoActual") }}
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          @if (tipoUsuario == 'intermediario') {
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                              <div class="mb-3">
                                                <label class="form-label" for="estadoActual">Estado actual</label>
                                                <div class="form-control">
                                                  {{ getSolicitudData("HistorialSolicitud", "EstadoIntermediario") }}
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          @if (getSolicitudData('HistorialSolicitud', 'observaciones') &&
                                            (getSolicitudData('HistorialSolicitud', 'observacionBancoldex') != getSolicitudData('HistorialSolicitud', 'observaciones'))) {
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12"
                                              >
                                              <div class="mb-3">
                                                <label class="form-label" for="observaciones">Observaciones</label>
                                                <textarea class="form-control" style="height: 100px;"
                                                [disabled]="true">{{getSolicitudData('HistorialSolicitud', 'observaciones')}}</textarea>
                                              </div>
                                            </div>
                                          }
                                          @if (getSolicitudData('HistorialSolicitud', 'observacionBancoldex') && tipoUsuario == 'intermediario') {
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12"
                                              >
                                              <div class="mb-3">
                                                <label class="form-label" for="observacionesBx">Observaciones Bancóldex</label>
                                                <textarea class="form-control" style="height: 100px;"
                                                [disabled]="true">{{getSolicitudData('HistorialSolicitud', 'observacionBancoldex')}}</textarea>
                                              </div>
                                            </div>
                                          }
                                          @if (esIntermediario) {
                                            <form action="" [formGroup]="formObservacionGestionAliado"
                                              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                              @if (isObserbacionGestion) {
                                                <div>
                                                  <div class="mb-3 required" [ngClass]="{'is-invalid':validarObservacion('observacionGestion')}">
                                                    <label class="form-label" for="gestionMicoempresario">¿Quieres informar la gestión realizada con el microempresario?</label>
                                                    <textarea class="form-control" style="height: 100px;" formControlName="observacionGestion"
                                                    [maxlength]="500" required [ngClass]="{'is-invalid':validarObservacion('observacionGestion')}"></textarea>
                                                    <div class="invalid-feedback">
                                                      Campo obligatorio
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
                                                    <div class="mb-3 text-end">
                                                      <button class="btn btn-primary hvr-shrink" style="width: 180px"
                                                      [disabled]="formObservacionGestionAliado.invalid" (click)="addRow()">Agregar</button>
                                                    </div>
                                                  </div>
                                                </div>
                                              }
                                              @if (observacionesAliados.length>0) {
                                                <div class="text-center mt-3">
                                                  <div class="table-responsive">
                                                    <table class="table table-striped table-borderless rounded" id="tablaObservaciones">
                                                      <thead class="table_head">
                                                        <tr>
                                                          <th scope="col" class="no-styles table-header" id="fecha">
                                                            Fecha registro observación
                                                          </th>
                                                          <th scope="col" class="no-styles table-header" id="nombreUsuario">
                                                            Nombre usuario
                                                          </th>
                                                          <th scope="col" class="no-styles table-header" id="observacion">
                                                            Observación
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody id="tbody">
                                                        @for (item of observacionesAliados; track item; let i = $index) {
                                                          <tr id="fila">
                                                            <td>
                                                              {{item.fechaActualizacion|date: 'dd/MM/yyyy hh:mm a' : "en-CA"}}
                                                            </td>
                                                            <td>
                                                              {{separarString(item.nombreUsuario)}}
                                                            </td>
                                                            <td>
                                                              {{item.observacion}}
                                                            </td>
                                                          </tr>
                                                        }
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              }
                                            </form>
                                          }
                                        </div>
                                      </div>
                                      <div class="text-center mt-3" [class.detalle-solicitud-v2__actions]="esVistaMicroempresario">
                                        <button
                                          type="button"
                                          (click)="goBack()"
                                          [class]="esVistaMicroempresario ? 'detalle-solicitud-v2__btn-volver' : 'btn btn-primary hvr-shrink'"
                                          [style.width]="esVistaMicroempresario ? null : '180px'"
                                        >
                                          Volver
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="footer-body" [class.footer-body--hidden]="esVistaMicroempresario"></div>
                                  @if (esVistaMicroempresario) {
                                    <div class="home-v2__bubbles" aria-hidden="true">
                                      <span class="home-v2__bubble home-v2__bubble--lg"></span>
                                      <span class="home-v2__bubble home-v2__bubble--sm"></span>
                                    </div>
                                  }
                                </div>
                                @if (esVistaMicroempresario) {
                                  <div class="home-v2__chrome">
                                    <app-home-site-footer [skipCms]="true"></app-home-site-footer>
                                  </div>
                                } @else {
                                  <app-footer></app-footer>
                                }
                                <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
